import React, { Fragment, useCallback, useState } from 'react';
import Button from '@atlaskit/button/standard-button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import Form, { Field, FormSection } from '@atlaskit/form';
import Select, { OptionType, ValueType } from '@atlaskit/select';
import { NotificationFlag, useApplicationContext, useFeatureToggle } from '@css-xp/base';
import { ButtonItem } from '@atlaskit/menu';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import { N500 } from '@atlaskit/theme/colors';
import { defaultTimeZone, timeZones } from './zones';
import './time-zone-picker.scss';
import { ENABLE_MULTIPLE_TIME_ZONE } from '@atlassian/cssxp-utils-generic';
import { FlagGroup } from '@atlaskit/flag';
interface Category {
  timeZone?: ValueType<OptionType>;
}

export const TimeZone = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [displayFlag, setDisplayFlag] = useState(false);
  const [isEnabled] = useFeatureToggle();

  const openModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);
  const context = useApplicationContext();

  const showFlag = () => setDisplayFlag(true);
  const hideFlag = () => setDisplayFlag(false);

  const handleFormSubmit = (data: Category) => {
    const zone: Category = data;
    context.setTimeZone(zone.timeZone?.value);
    closeModal();
    showFlag();
  };

  return (
    isEnabled(ENABLE_MULTIPLE_TIME_ZONE) && (
      <>
        <ButtonItem onClick={openModal}>Time Zone</ButtonItem>
        <ModalTransition>
          {isOpen && (
            <Modal onClose={close}>
              <Form onSubmit={handleFormSubmit}>
                {({ formProps }) => (
                  <form {...formProps} id="timeZoneForm">
                    <ModalHeader>
                      <ModalTitle>Select your Time zone</ModalTitle>
                      <Button spacing={'none'} tabIndex={-1} onClick={closeModal} appearance={'subtle'}>
                        <EditorCloseIcon label="Close Modal" primaryColor={N500} />
                      </Button>
                    </ModalHeader>
                    <ModalBody>
                      <p>Choose time zone to reflect in Order History and Audit Trial</p>
                    </ModalBody>
                    <FormSection>
                      <Field<ValueType<OptionType>> name="timeZone" id="timeZone" defaultValue={defaultTimeZone}>
                        {({ fieldProps: { id, ...rest } }) => (
                          // @ts-ignore
                          <Select id={`time-zone-select`} options={timeZones} {...rest} />
                        )}
                      </Field>
                    </FormSection>
                    <ModalFooter>
                      <Button type="submit" form="timeZoneForm" appearance="primary">
                        Submit
                      </Button>
                    </ModalFooter>
                  </form>
                )}
              </Form>
            </Modal>
          )}
        </ModalTransition>
        <FlagGroup onDismissed={hideFlag}>
          {displayFlag && (
            <NotificationFlag
              id="timeZoneChangedFlag"
              header="We're updating your time zone"
              type="success"
              message="Your change might take a while to show in Order history and Audit trial."
            />
          )}
        </FlagGroup>
      </>
    )
  );
};
